import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enLocales from "./en.json";
import viLocales from "./vi.json";

const search = window.location.search;
const params = new URLSearchParams(search);
const language = params.get("language");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources:
      language === "vi"
        ? {
            vi: { translations: viLocales },
          }
        : {
            en: { translations: enLocales },
          },
    lng: "en",
    fallbackLng: ["en", "vi"],
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
